<!--
  - Copyright (c) 2020 brightlamp
  -->

<template>
    <v-data-iterator
        :items="items"
        hide-default-footer>
        <template v-slot:item="props">
            <v-row>
                <v-col :cols="12">
                    <v-card>
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>Concussion Date:</v-list-item-content>
                                <v-list-item-content>{{ props.item.concussionDate }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Is Asymptomatic:</v-list-item-content>
                                <v-list-item-content>{{ props.item.asymptomatic }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>Glasgow Coma Scale:</v-list-item-content>
                                <v-list-item-content>{{ props.item.glasgowComaScale }}</v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-data-iterator>
</template>

<script>

import { mapState } from 'vuex'
export default
{
    name: 'test-concussion-data',
    data: function ()
    {
        return {
            items:
            [
                {
                    concussionDate: 'N/A',
                    asymptomatic: 'N/A',
                    glasgowComaScale: 'N/A'
                }
            ]
        }
    },
    props:
    {
        resultData: {}
    },
    computed:
    {
        ...mapState('auth',
        {
            currentUser: state => state.currentUser
        })
    },
    watch:
    {
        resultData()
        {
            this.resultDataCommon()
        }
    },
    mounted()
    {
        this.resultDataCommon()
    },
    methods:
    {
        resultDataCommon: function ()
        {
            if (this.resultData.concussionData)
            {
                this.items[0].concussionDate = this.resultData.concussionData.concussionDate ? new Date(this.resultData.concussionData.concussionDate).toLocaleDateString(navigator.languages[0], {timeZone: 'UTC'}) : 'N/A';
                this.items[0].asymptomatic = this.resultData.concussionData.asymptomatic ? 'Yes' : 'No';
                this.items[0].glasgowComaScale = this.resultData.concussionData.glasgowComaScale ? this.resultData.concussionData.glasgowComaScale : 'N/A'
            }
        }
    }
};
</script>

<style scoped>
</style>